"use client";

import React, { useEffect, useRef, useState } from "react";
import { CMSLink } from "../../components/CMSLink";
import { Icon } from "../Icon";
import { ChevronDownIcon } from "@heroicons/react/24/outline";

export const NavItem = ({ navItem }: { navItem: any }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const hasSubNav = navItem.subNavigation && navItem.links?.length > 0;

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  return (
    <div className="relative" ref={dropdownRef}>
      <div className="flex items-center gap-1 cursor-pointer group">
        {navItem.reactIconsIcon && (
          <Icon
            reactIconsIcon={navItem.reactIconsIcon}
            className="text-white text-2xl"
          />
        )}

        {hasSubNav ? (
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center gap-1 text-white text-sm leading-tight hover:[text-shadow:0.5px_0_currentColor]"
          >
            {navItem.link.label}
            <ChevronDownIcon
              className={`w-3 h-3 transition-transform ${isOpen ? "rotate-180" : ""}`}
            />
          </button>
        ) : (
          <CMSLink
            {...navItem.linkWithMedia}
            appearance="inline"
            className="relative hover:bg-gradient-to-r from-primary to-secondary hover:bg-[length:100%_2px] hover:bg-no-repeat hover:bg-bottom pb-1"
          />
        )}
      </div>

      {hasSubNav && isOpen && (
        <div className="absolute left-0 mt-2 w-48 bg-black border border-white/10 rounded-md shadow-xl z-[60] py-2">
          {navItem.links.map((subLink: any) => (
            <div
              key={subLink.id}
              className="px-4 py-2 hover:bg-white/10 transition-colors"
            >
              <CMSLink {...subLink.link} appearance="inline" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
